export enum RabbitSignApiKeyType
{
    None = 0,
    Nowcerts = 1,
    Agency = 2,
    Agent = 3,
}